"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = void 0;
var connected_react_router_1 = require("connected-react-router");
var cartActions = require("@caddigital/sok-reducers/lib/actions/cart");
var FilesActions = require("@caddigital/sok-reducers/lib/actions/files");
var ToastActions = require("@caddigital/sok-reducers/lib/actions/toast");
var download_1 = require("utils/download");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var mapDispatchToProps = function (dispatch) { return ({
    onFetchItems: function (rootId) {
        dispatch(cartActions.fetchItems(rootId));
    },
    onRemoveItem: function (rootId) { return function (id) {
        return dispatch(cartActions.removeItems([id], rootId));
    }; },
    onClose: function () {
        dispatch(cartActions.toggleCart()),
            dispatch(cartActions.cancelFetch()),
            dispatch(cartActions.showCartInfo(false));
    },
    showCartInfoText: function (isInfoVisible) {
        return dispatch(cartActions.showCartInfo(isInfoVisible));
    },
    onClearAll: function (rootId) {
        dispatch(cartActions.clearAll(rootId)), dispatch(cartActions.cancelFetch());
    },
    toggleMoveCopyFilesOverlay: function (mode) {
        dispatch(cartActions.toggleCart());
        dispatch(cartActions.showCartInfo(false));
        dispatch(FilesActions.FolderTreeActions.copyFilesToggleOverlay(mode));
        dispatch(FilesActions.FolderTreeActions.setCopyOrMoveRootExpanded(true));
    },
    createNewOrder: function (language, projectId, mode, pathname) { return (dispatch(cartActions.toggleCart()),
        dispatch((0, connected_react_router_1.push)("/".concat(language, "/projects/").concat(projectId, "/").concat(mode === 'SINGLE' ? 'orders' : 'automatic-orders', "/create"), { from: pathname })),
        dispatch(cartActions.showCartInfo(false))); },
    openMetadataModal: function (baseUrl) { return function () {
        dispatch((0, connected_react_router_1.push)("".concat(baseUrl.split('/').splice(-1, 1).join('/'), "/metadata")));
        dispatch(cartActions.toggleCart());
    }; },
    downloadFiles: function (files, token) {
        return function () {
            dispatch(cartActions.toggleCart());
            dispatch(cartActions.showCartInfo(false));
            var retVal = dispatch(ToastActions.addNewToast((0, translation_1.getLocalization)('files/toast/download/loading-title'), (0, translation_1.getLocalization)('files/toast/download/loading-text'), 'NORMAL', [], undefined, 0));
            var uuid = retVal.payload.uuid;
            (0, download_1.downloadFiles)(token, files, undefined, undefined, function () {
                return dispatch(ToastActions.removeToast(uuid));
            });
        };
    },
    fetchCartItems: function (files) { return dispatch(cartActions.fetchFiles(files)); }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
